import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import {
    UserInfoCard,
    RankingCard,
    WalkingDataCard,
    HeartRateDataCard,
    DidimActivityCard,
    StressIndexCard
} from '../cards';
import { formatDateTime } from '../../../../utils/base';

export const DashboardTab = ({
    userData,
    physicalRecord,
    membership = null,
    playLogsData = [],
    organizationName = '',
    skill = {
        endurance: 0,
        strength: 0,
        balance: 0,
        flexibility: 0,
        reaction: 0,
        cooperation: 0,
    },
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // 오늘 날짜 확인 함수
    const isToday = () => {
        if (!physicalRecord?.date) return false;
        const today = formatDateTime(new Date(), '', '', 0, 8); // yyyy-mm-dd 형식
        const recordDate = formatDateTime(physicalRecord.date, '', '', 0, 8); // date를 yyyy-mm-dd 형식으로 변환
        return recordDate === today;
    };

    // 오늘 데이터인 경우만 physicalRecord 전달
    const todayPhysicalRecord = isToday() ? physicalRecord : null;


    return (
        <Box sx={{ flex: 1, display: 'flex', gap: 2 }}>
            {/* 좌측 컬럼 */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <UserInfoCard
                    userData={userData}
                />

                <WalkingDataCard
                    physicalRecord={physicalRecord}
                />

                <HeartRateDataCard
                    physicalRecord={todayPhysicalRecord}
                />

                <StressIndexCard
                    physicalRecord={todayPhysicalRecord}
                />
            </Box>

            {/* 우측 컬럼 */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <RankingCard
                    userData={userData}
                    membership={membership}
                />

                <DidimActivityCard
                    organizationName={organizationName}
                    playLogsData={playLogsData}
                    skill={skill}
                />
            </Box>
        </Box >
    );
};
